import type { TGrowthOverviewRowType } from "../types";

export const buildGrowthOverviewRowId = (
    rowType: TGrowthOverviewRowType,
    category: string,
    domain?: string | null,
): string => {
    if (rowType === "domain") {
        return domain ? `domain:${category}::${domain}` : `domain:${category}`;
    }

    return `${rowType}:${category}`;
};
